module.exports = __webpack_public_path__ + "static/img/nav13.3b2391cc.svg";